interface IQueryTouchRecognizer {
    isFulfilled(start: QueryTouchDetails, current: QueryTouchDetails) : boolean | null;
    
    onStart(details: QueryTouchDetails) : Promise<void>;
    onMove(start: QueryTouchDetails, current: QueryTouchDetails) : Promise<void>;
    onStop(details: QueryTouchDetails, stop: QueryTouchDetails) : Promise<void>;
}
interface IQueryTouchRecognizerConfig {
    // Distance in px
    threshold: number        
    // Required pointers           
    pointers: number        
    // Direction            
    direction: QueryTouchDirection
}
abstract class QueryTouchRecognizer<T extends IQueryTouchRecognizerConfig>
    implements IQueryTouchRecognizer {

    private readonly _config: T;

    constructor(config: T) {
        this._config = config;
    }

    public get config() { return this._config; }

    abstract onStart(details: QueryTouchDetails) : Promise<void>;
    abstract onMove(details: QueryTouchDetails, current: QueryTouchDetails) : Promise<void>;
    abstract onStop(details: QueryTouchDetails, stop: QueryTouchDetails) : Promise<void>;
    abstract isFulfilled(details: QueryTouchDetails, current: QueryTouchDetails) : boolean | null;
}